import { render, staticRenderFns } from "./SoftwareDevelopmentSupervisor.vue?vue&type=template&id=c2bdf7e0&scoped=true&"
import script from "./SoftwareDevelopmentSupervisor.vue?vue&type=script&lang=js&"
export * from "./SoftwareDevelopmentSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareDevelopmentSupervisor.vue?vue&type=style&index=0&id=c2bdf7e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bdf7e0",
  null
  
)

export default component.exports